import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { JobSkill } from '../../shared/models/job-skill';
import { BusinessDetails } from '../models/business-details';
import { JobPost } from '../../jobs/models/job-post';
import { DataService } from '../services/data.service';

@Injectable({
  providedIn: 'root'
})
export class EmployerStore {

  _businessDetails: BehaviorSubject<BusinessDetails> = new BehaviorSubject(null);
  public readonly BusinessDetails: Observable<BusinessDetails> = this._businessDetails.asObservable();

  _profilePhoto: BehaviorSubject<string> = new BehaviorSubject(null);
  public readonly profilePhoto: Observable<string> = this._profilePhoto.asObservable();

  _jobPost: BehaviorSubject<JobPost> = new BehaviorSubject(null);
  public readonly jobPost: Observable<JobPost> = this._jobPost.asObservable();

  _jobPosts: BehaviorSubject<JobPost[]> = new BehaviorSubject([]);
  public readonly jobPosts: Observable<JobPost[]> = this._jobPosts.asObservable();

  _skills: BehaviorSubject<JobSkill[]> = new BehaviorSubject([]);
  public readonly skills: Observable<JobSkill[]> = this._skills.asObservable();

  constructor() { }

  public setBusinessDetails(businessDetails: BusinessDetails): void {
    this._businessDetails.next(businessDetails);
    if (businessDetails.photoPath) {
      this.setProfilePath(businessDetails.photoPath);
    }

  }

  public setProfilePath(path: string): void {
    if(this._profilePhoto.getValue() == path) {
      return;
    }

    const business = this._businessDetails.getValue();
    if (business) {
      business.photoPath = path;
    }

    this._profilePhoto.next(path);
  }

  public setJobPost(jobPost: JobPost): void {
    this._jobPost.next(jobPost);
    this._skills.next(jobPost.skills);
  }

  public setJobPosts(jobPosts: JobPost[]): void {
    this._jobPosts.next(jobPosts);
  }

  public getSkills(): JobSkill[] {
    return this._skills.getValue();
  }

  public addSkill(skill: JobSkill): void {
    this._skills.getValue().push(skill);
  }

  clearSkills(): void {
    this._skills.next([]);
  }

  public updateListSkill(skill: JobSkill): void {
    let skillCount = this._skills.getValue().length;
    this._skills.getValue()[skillCount - 1] = skill;
  }

  public removeSkill(index: number): void {
    let skills = this._skills.getValue();
    if(skills.length == 1) {
      return;
    }

    skills.splice(index, 1);
    this._skills.next(skills);
  }

}
